import React, {useContext} from 'react';
import {FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {Padding} from '@gongxigames/framework/core';
import {PayTableContext} from '@gongxigames/framework/slot/modules/oddsUpfront/OddsUpfrontReactView';

type PayTableRowProps = {
    symbols: [string, string][];
    isMobile: boolean;
};

export function PayTableRow({symbols, isMobile}: PayTableRowProps): JSX.Element {
    const padding: Padding = {top: 0, left: 0, right: 0, bottom: isMobile ? 50: 30};
    const {SymbolComponent} = useContext(PayTableContext);
    const pays = symbols.map(([symbolId, src]) => <SymbolComponent
        src={src}
        symbolId={symbolId}
        key={symbolId}
    />);

    return (
        <FlexBoxComponent name='PayTableRow' alignItems={'center'} gap={150} padding={padding}>
            {pays}
        </FlexBoxComponent>
    );
}
